export default {
  fleetTypes: [],
};
